import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { EmailRecipientsParams, fetchEmailRecipients } from "./api"

function hasAnyIds(params: EmailRecipientsParams): boolean {
  return (
    (params.household_ids?.length ?? 0) > 0 ||
    (params.contact_ids?.length ?? 0) > 0 ||
    (params.person_ids?.length ?? 0) > 0
  )
}

export function useFetchEmailRecipients(params: EmailRecipientsParams, enabled = true) {
  const getContext = useApiContext()
  return useQuery({
    queryKey: ["emailRecipients", params],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchEmailRecipients(context, params)
    },
    enabled: enabled && hasAnyIds(params),
  })
}
